import React, { useEffect } from "react";
import useStore from "../store/useStore";

export default function VideoInstitucional() {
  const { misimVideos, fetchMisimVideos } = useStore();

  useEffect(() => {
    fetchMisimVideos();
  }, [fetchMisimVideos]);

  // Toma el primer video disponible
  const videoUrl = misimVideos[0]?.video?.url || "";
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  return (
    <section aria-label="Video institucional">
      <div className="w-full aspect-video max-h-[900px]">
        {videoUrl ? (
          <video
            autoPlay
            playsInline
            muted
            loop
            className="w-full h-full object-cover aspect-video"
          >
            <source src={urlApi + videoUrl} type="video/mp4" />
          </video>
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-200 dark:bg-sidom-blue rounded-2xl">
            <span className="text-sidom-dark dark:text-sidom-light">
              Video no disponible
            </span>
          </div>
        )}
      </div>
      <div className="container mt-[60px] mb-[70px] md:mb-[100px] lg:mb-[90px]">
        <h1 className="text-sidom-orange leading-[1.5] text-3xl md:text-[40px] lg:text-[45px] font-extrabold text-left mb-[30px]">
          La solución más elegida en el mercado{" "}
          <span className="leading-[1.4] font-normal">
            para la gestión de estudios aduaneros
          </span>
        </h1>
        <p className="text-xs sm:text-sm md:text-base lg:text-xl text-left leading-relaxed">
          Resolvé las principales dificultades operativas a partir de la
          aplicación de tecnología IA y RPA. Toda la gestión se realiza en
          remoto desde cualquier lugar del país, sin necesidad de disponer de
          terminales físicas exclusivas para Malvina.
        </p>
      </div>
    </section>
  );
}
